document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-masked-link').forEach(link => {
    link.addEventListener('click', () => {
      const target = link.getAttribute('data-target');
      if (target) {
        window.location.href = target;
      }
    });

    // Barrierefreiheit
    link.setAttribute('role', 'link');
    link.setAttribute('tabindex', '0');
    link.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') {
        const target = link.getAttribute('data-target');
        if (target) {
          window.location.href = target;
        }
      }
    });
  });
});